function Button({text}) {
    return(
        <button>{text}</button>
    )
}

export default Button